import Cart from './Cart';

export default class User {
	full_name = '';
	dnumber = '';
	bpnumber = '';
	phone = '';
	status = '';
	email = '';
	rights = [];
	status = '';
	country = {
		name: '',
		short_name: '',
		currency: {
			name: '',
			symbol: '',
		},
	};
	sales_details = {
		manager_name: '',
		sales_office: '',
	};

	constructor(user) {
		this.full_name = user.FullName;
		this.dnumber = user.UserId.toUpperCase();
		this.bpnumber = user.BusinessPartnerNo;
		this.phone = user.Address.Phone;
		this.status = user.Status;
		this.email = user.Address.Email;
		this.rights = user.AccessRights;
		this.status = user.Status;
		this.first_name = user.FirstName;
		this.last_name = user.LastName;
		this.middle_name = user.MiddleName;
		this.country = {
			name: user.CountryConfiguration.CountryShortName3Letters,
			short_name: user.CountryConfiguration.CountryShortName,
			long_name: user.Country,
			currency: {
				name: user.CountryConfiguration.CurrencyName,
				symbol: user.CountryConfiguration.CurrencySymbol,
			},
		};
		this.sales_details = {
			manager_name: user.SalesDetails.ManagerName,
			sales_office: user.SalesDetails.SalesOffice,
		};
		this.user_types = user.UserTypes;
		this.cart = new Cart(user.ShoppingCartItems);
	}
}



// WEBPACK FOOTER //
// ./src/api/models/User.js